import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Outlet, Navigate, useLocation, useParams } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { BookingProvider } from "./context/BookingContext";
import { SiteProvider, useEmbedHeight, useTrackSource } from "./context/SiteContext";
import { setSite } from "./lib/api";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Hotels from "./pages/Hotels";
import Rates from "./pages/Rates";
import SearchWidget from "./pages/SearchWidget";
import Services from "./pages/Services";
import Details from "./pages/Details";
import Confirmation from "./pages/Confirmation";
import Payment from "./pages/Payment";
import FindReservation from "./pages/FindReservation";
import AdminLogin from "./pages/admin/AdminLogin";
import ResetPassword from "./pages/admin/ResetPassword";
import AdminDashboard from "./pages/admin/AdminDashboard";
import SuperadminPage from "./pages/superadmin/SuperadminPage";
import WebsiteEditor from "./pages/website/WebsiteEditor";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.self !== window.top) window.parent.postMessage({ type: "eres-booking-nav" }, "*");
  }, [pathname]);
  return null;
};

const bareMode = (slug) => {
  if (window.self === window.top) return false;
  const key = `eres-bare-${slug}`;
  if (new URLSearchParams(window.location.search).get("bare") === "1") sessionStorage.setItem(key, "1");
  return sessionStorage.getItem(key) === "1";
};

const SiteShell = () => {
  const { slug } = useParams();
  setSite(slug);
  useEmbedHeight();
  useTrackSource(slug);
  const [bare] = useState(() => bareMode(slug));
  const widget = useLocation().pathname.endsWith("/widget");
  return (
    <SiteProvider slug={slug}>
      <BookingProvider key={slug} slug={slug}>
        <div className={`font-sans text-ink ${widget ? "bg-transparent" : "grain bg-sand"} ${bare ? "" : "min-h-screen"}`} data-bare={bare ? "1" : "0"}>
          {!bare && !widget && <Header />}
          <main><Outlet /></main>
          {!bare && !widget && <Footer />}
        </div>
      </BookingProvider>
    </SiteProvider>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Routes>
        <Route path="/s/:slug" element={<SiteShell />}>
          <Route index element={<Home />} />
          <Route path="hotels" element={<Hotels />} />
          <Route path="widget" element={<SearchWidget />} />
          <Route path="rates/:hotelId" element={<Rates />} />
          <Route path="services" element={<Services />} />
          <Route path="details" element={<Details />} />
          <Route path="payment/:cid" element={<Payment />} />
          <Route path="confirmation/:ref" element={<Confirmation />} />
          <Route path="find-reservation" element={<FindReservation />} />
        </Route>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/reset-password" element={<ResetPassword />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/superadmin" element={<SuperadminPage />} />
        <Route path="/website-admin/:wid" element={<WebsiteEditor />} />
        <Route path="*" element={<Navigate to="/superadmin" replace />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
